import Modal from 'src/components/common/modal/modal';
import css from '../subscribe.module.scss';

interface SuccesModalProps {
  isOpen: boolean;
  email: string;
  onClose: () => void;
}

export default function SuccesModal({ isOpen, email, onClose }: Readonly<SuccesModalProps>) {
  return (
    <Modal isOpen={isOpen} closeOnDocumentClick={false} onClose={onClose}>
      {(close: () => void) => (
        <div className={css.succesModal}>
          <button className={css.close} onClick={close}>
            &times;
          </button>
          <h3>Вашу підписку оформлено</h3>
          <p>
            Налаштування для <span>{email}</span> збережнено.
            <br /> Дякуємо що ви з нами на зв’язку!
          </p>
          <button className={css.actionBtn} onClick={close}>
            Дякую
          </button>
        </div>
      )}
    </Modal>
  );
}
